module.exports = __webpack_public_path__ + "img/s7.58a4b20.png";